import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DsBoxModule,
  DsRowData,
  DsButtonModule,
  DsLinkModule,
  DsSkeletonModule,
  DsFormsModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
} from '@bmw-ds/components';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonService } from 'src/app/services/common.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-campaign-inventory-internal-search',
  imports: [
    CommonModule,
    DsBoxModule,
    DsButtonModule,
    DsLinkModule,
    DsSkeletonModule,
    DsFormsModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './campaign-inventory-internal-search.html',
  styleUrls: ['./campaign-inventory-internal-search.scss'],
  standalone: true,
})
export class CampaignInventoryInternalSearch implements OnInit {
  componentName: string = '';
  @Input() selectedValue: string = '';
  defectCodeForm: FormGroup;
  isDefectCodeLoading: boolean = false;
  path: string = '';
  currentDate: string = '';
  currentTime: string = '';
  defectCodeTableData: any;
  loadingAreaConfig: DsLoadingAreaConfiguration = {
    id: 'bodyLoading',
    loadingTitle: 'Details are being displayed, this may take few seconds..',
    loadingText:
      'Please do not close the browser window. wait while we load data.',
  };
  defectCodePayload: any;
  nationalScreenSelectedValue: string = '';
  regionScreenSelectedValue: string = '';
  marketScreenSelectedValue: string = '';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private apiService: ApiService,
    private loadingAreaService: DsLoadingAreaService
  ) {
    this.defectCodeForm = new FormGroup({
      defectCode: new FormControl('', [Validators.pattern(/^[a-zA-Z0-9\s]+$/)]),
    });

    // console.log('defectCodeForm ', this.defectCodeForm, this.defectCodeForm.value, this.defectCodeForm.value.defectCode);
  }
  ngOnInit() {
    this.applyRouteContext();
    // Update on navigation changes if component stays mounted
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => {
        this.applyRouteContext();
      });
    // console.log('componentName:', this.componentName);
    this.commonService.updateDateAndTime();
    this.currentDate = this.commonService.currentDate;
    this.currentTime = this.commonService.currentTime;
    // console.log('selectedValue:', this.selectedValue);
    const savedDefectCode = this.commonService.defectCode.getValue();
    const currentDefectCode = this.defectCodeForm.get('defectCode')?.value;
    // When navigated via the nav icon, start fresh — don't restore the previous value
    const isNavIconClicked = this.commonService.isNavIconClicked.getValue();  
    if (isNavIconClicked && this.componentName === 'National') {
      this.defectCodeForm.reset();
      this.commonService.defectCode.next('');
      this.commonService.isNavIconClicked.next(false);
    } else{
      this.defectCodeForm.patchValue({ defectCode: savedDefectCode });
      this.commonService.defectCode.next(savedDefectCode);
      
    }
    this.onSearch();
  }

  private applyRouteContext() {
    const currentUrl = this.router.url || '';
    const routePath = this.activatedRoute.snapshot.routeConfig?.path || '';
    const url = (routePath || currentUrl).toLowerCase();

    if (url.includes('campaign_inventory_internal_market')) {
      this.path = 'CampaignInventoryInternalMarket';
      this.componentName = 'Market';
    } else if (url.includes('campaign_inventory_internal_region')) {
      this.path = 'CampaignInventoryInternalRegion';
      this.componentName = 'Regional';
    } else {
      this.path = 'CampaignInventoryInternalNational';
      this.componentName = 'National';
    }
  }

  onSearch() {
    if (this.defectCodeForm.valid) {
      this.commonService.defectCode.next(this.defectCodeForm.value.defectCode);
      this.isDefectCodeLoading = true;   
      this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
      const params = this.activatedRoute.snapshot.queryParams 
        || this.router.routerState.snapshot.root.queryParams;
      if(this.componentName === 'National'){
      this.defectCodePayload = {
        "defectCode": this.defectCodeForm.value.defectCode || null,
        "region": "",
        "market": "",
        "marketCode": "",
        "nationalScreen": true,
        "regionScreen": false,
        "marketScreen": false
      };
    }
    if(this.componentName === 'Regional'){
      this.nationalScreenSelectedValue = params['value'] || '';
      // console.log('Selected Value from query params:', this.nationalScreenSelectedValue);
      this.commonService.nationalScreenSelectedValue.next(this.nationalScreenSelectedValue);
      this.defectCodePayload = {
        "defectCode": this.defectCodeForm.value.defectCode || null,
        "region": this.nationalScreenSelectedValue || "",
        "market": "",
        "marketCode": "",
        "nationalScreen": false,
        "regionScreen": true,
        "marketScreen": false
      };
    }
      if (this.componentName === 'Market') {
        this.regionScreenSelectedValue = params['value'] || '';
        // console.log('Selected Value from query params:', this.regionScreenSelectedValue);
        this.commonService.regionalScreenSelectedValue.next(this.regionScreenSelectedValue);
          this.defectCodePayload = {
          "defectCode": this.defectCodeForm.value.defectCode || null,
          "region": "",
          "market": this.regionScreenSelectedValue.split("-")[0] || "",
          "marketCode": this.regionScreenSelectedValue.split("-")[1]?.trim() || "",
          "nationalScreen": false,
          "regionScreen": false,
          "marketScreen": true
        };
      }
      this.apiService.getNationalScreenData(this.defectCodePayload).subscribe({
        next: (data: any) => {
          this.commonService.defectCodeTableData.next(data);
        },

        error: (error: any) => {
          console.error('Error fetching National Table Data:', error);
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id); // Removes the loading area
        },
        complete: () => {
          // console.log('National Table Data fetch completed');
          this.isDefectCodeLoading = false;
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id); // Removes the loading area
        },
      });
    }
  }
  onClearSelection() {
    this.commonService.updateDateAndTime();
    this.currentDate = this.commonService.currentDate;
    this.currentTime = this.commonService.currentTime;
    this.defectCodeForm.reset();
    this.onSearch();
    this.isDefectCodeLoading = false;
  }

  onRefresh() {
    console.log('Refresh clicked');
    this.onClearSelection();
  }
}
